module.exports = __webpack_public_path__ + "static/img/background.01af9d48.svg";